import { Check } from "lucide-react";

const plans = [
  {
    name: "Monthly",
    duration: "1 Month",
    price: "₹34,999",
    features: [
      "15 Campaigns Per Month",
      "End-To-End Campaign Execution",
      "Al-Powered Influencer Recommendations",
      "Detailed Audience Insights",
      "Real-Time Performance Tracking",
      "Brand Sentiment Insights",
      "WhatsApp & Email Notifications",
    ],
  },
  {
    name: "3 Months",
    duration: "(+1 month free)",
    price: "₹87,999",
    features: [
      "20 Campaigns Per Month",
      "End-To-End Campaign Execution",
      "Al-Powered Influencer Recommendations",
      "Detailed Audience Insights",
      "Real-Time Performance Tracking",
      "Brand Sentiment Insights",
      "WhatsApp & Email Notifications",
    ],
  },
];

export default function PricingPlans() {
  return (
    <section className="bg-white py-10">
      <div className="container mx-auto px-4 sm:max-w-[90%] md:max-w-[70%]">
        <div className="grid gap-8 md:grid-cols-2 max-w-4xl mx-auto">
          {plans.map((plan, index) => (
            <div
              key={index}
              className="rounded-lg border border-gray-200 bg-white p-8 shadow-sm"
            >
              <h2 className="mb-2 text-2xl font-bold">{plan.name}</h2>
              <p className="mb-4 text-gray-600">{plan.duration}</p>
              <p className="mb-6 text-4xl font-bold">{plan.price}</p>
              <ul className="mb-6 space-y-2">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center">
                    <Check className="mr-2 h-5 w-5 text-green-500 flex-shrink-0" />
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
